import { MenuItem } from '../../components/ui/menu'
import { ItemPredicate, ItemRenderer, Select } from '@blueprintjs/select'
import React, { useState, useEffect } from 'react'
import { useUser } from '../../hooks/useUser'
import { Button } from '../../components/ui/button'
import { type EntityId, idKey } from '../../types/constants'

export const Sink2 = () => {
    return (
        <div className="sink">
            <div className="w-84 h-80"></div>
            <Container />
        </div>
    )
}

export interface Profile {
    title: string
    id: EntityId
}

const filterProfile: ItemPredicate<Profile> = (query, profile, _index, exactMatch) => {
    const normalizedTitle = profile.title.toLowerCase()
    const normalizedQuery = query.toLowerCase()

    if (exactMatch) {
        return normalizedTitle === normalizedQuery
    } else {
        return `${profile.id}. ${normalizedTitle} ${profile.title}`.indexOf(normalizedQuery) >= 0
    }
}

const renderFilm: ItemRenderer<Profile> = (film, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) {
        return null
    }
    return (
        <MenuItem
            active={modifiers.active}
            disabled={modifiers.disabled}
            key={film.id}
            label={film.title.toString()}
            onClick={handleClick}
            text={`${film.title}`}
        />
    )
}

const ProfileSelect: React.FC = () => {
    const { profiles, profile: activeProfile } = useUser()
    const [managedProfiles, setManagedProfiles] = useState<Profile[] | undefined>(undefined)
    const [selectedProfile, setSelectedProfile] = React.useState<Profile | undefined>(undefined)
    console.log('profile is', profiles)

    useEffect(() => {
        const output: Profile[] = []
        profiles.forEach((profile) => {
            if (!selectedProfile && profile.managed) {
                if (idKey(activeProfile) === idKey(profile.profile_id)) {
                    setSelectedProfile({
                        id: profile.profile_id,
                        title: profile.name,
                    })
                }
            }
            if (profile.managed) {
                output.push({
                    id: profile.profile_id,
                    title: profile.name,
                })
            }
        })
        setManagedProfiles(output)
    }, [profiles, activeProfile])

    return (
        <div>
            <Select<Profile>
                items={managedProfiles ?? []}
                itemPredicate={filterProfile}
                itemRenderer={renderFilm}
                noResults={<MenuItem disabled={true} text="No results." />}
                onItemSelect={setSelectedProfile}
            >
                {managedProfiles ? (
                    <div>
                        {managedProfiles.length > 0 ? (
                            <div>
                                <Button
                                    outlined
                                    text={selectedProfile?.title}
                                    rightIcon="double-caret-vertical"
                                />
                            </div>
                        ) : (
                            <div>
                                <Button
                                    outlined
                                    disabled
                                    rightIcon="double-caret-vertical"
                                    text="No managed profiles found"
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        <Button
                            outlined
                            disabled
                            rightIcon="double-caret-vertical"
                            text="No profiles found"
                        />
                    </div>
                )}
            </Select>
        </div>
    )
}

const Container: React.FC = () => {
    const [isAlertShown, setAlertShown] = useState(false)

    const toggleAlert = () => {
        setAlertShown(!isAlertShown)
    }

    return (
        <div className="container" onClick={toggleAlert}>
            <div className="note">Tap</div>
            <div className={`alert ${isAlertShown ? 'is-shown' : ''}`}>Sub Menu Items</div>
        </div>
    )
}
